import React, { FC, useState } from "react";

import { useTranslation } from "react-i18next";
import { useMount } from "react-use";

import { useSort } from "@/components/atoms";
import SearchList from "@/components/templates/SearchList/SearchList";
import { Contract, ContractSortProperty, SortOrder } from "@/shared/domain";
import { useNavigation } from "@/shared/hooks";
import * as tagManager from "@/tagManager";
import { useUserFeedback } from "@/userFeedback";

import ContractItem from "../components/ContractItem/ContractItem";
import ContractTable from "../components/ContractTable/ContractTable";
import useContractQueries from "../useContractQueries";

const ContractSearchPage: FC = () => {
    const { t } = useTranslation();
    const { incUsageCount } = useUserFeedback();
    const [textSearch, setTextSearch] = useState("");
    const [orderBy, orderByActions] = useSort<ContractSortProperty>({
        sort: { property: "type", order: SortOrder.Descending },
    });
    const { navToFeatureDocuments } = useNavigation();
    const { tableMode, useContractsSearchQuery } = useContractQueries();
    const { result, isFetching } = useContractsSearchQuery({
        textSearch,
        sortProperty: orderByActions.getManualSortProperty(),
    });
    useMount(() => {
        incUsageCount();
        tagManager.pushViewItemListEvent("contract", "Contracts");
    });

    const renderItem = (contract) => <ContractItem key={contract.id} contract={contract} />;

    const renderTable = (items: Contract[]) => (
        <ContractTable contracts={items} orderBy={orderBy} handleSort={orderByActions.updateSort} />
    );

    return (
        <SearchList<Contract>
            items={result}
            tableMode={tableMode}
            textSearch={textSearch}
            setTextSearch={setTextSearch}
            renderItem={renderItem}
            renderTable={renderTable}
            isFetching={isFetching}
            openLinkedDocuments={() => navToFeatureDocuments("contracts")}
            placeholder={t("Common.Search")}
            emptyListMessage={t("Contracts.Empty")}
            pageTitle={t("Common.Contracts")}
        />
    );
};

export default ContractSearchPage;
